module.exports = __webpack_public_path__ + "static/media/features-section-1.8969955f.png";